<template>
  <div class="transactions">
    <div class="transactions-title">{{ $t('transactions') }}</div>
    <div class="transactions-list" v-if="transactions.length">
      <div
        class="transactions-item"
        v-for="transaction in transactions"
        :key="transaction.timestamp"
        :class="$style.historyItem"
        @click="showDetailTransaction(transaction)"
      >
        <div class="transactions-item__left">
          <div
            class="transactions-item__avatar"
            :class="{
              green: transaction.status === 'SUCCESS',
              yellow: transaction.status === 'PENDING',
              red:
                transaction.status === 'FAILED' || transaction.status === 'ERROR' || transaction.transactionType === 2
            }"
          >
            <img :src="user.avatarLink" alt="" v-if="transaction.initHolaId === user.id && user.avatarLink" />
            <img v-if="getUserAvatar(transaction.initHolaId)" :src="getUserAvatar(transaction.initHolaId)" alt="" />
          </div>
        </div>
        <div class="transactions-item__right">
          <div class="transactions-item__info">
            <div class="transactions-item__info-amount">
              <template v-if="transaction && (transaction.transactionType === 9 || transaction.transactionType === 10)">
                <span> ${{ parseFloat(transaction.amount).toFixed(2) }} </span>
              </template>
              <template v-else-if="transaction && transaction.transactionType === 2">
                <span> -${{ parseFloat(transaction.amount).toFixed(2) }} </span>
              </template>
              <template v-else>
                <span v-if="transaction.payload && transaction.payload.amount">
                  ${{ (parseFloat(transaction.payload.amount) + parseFloat(transaction.commission)).toFixed(2) }}
                </span>
                <span v-else>
                  ${{ (parseFloat(transaction.amount) + parseFloat(transaction.commission)).toFixed(2) }}
                </span>
              </template>
            </div>
            <div class="transactions-item__info-desc">{{ transaction.purpose }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="transactions-empty" v-if="!transactions.length">
      <img src="../../assets/img/empty-list-icon.png" alt="" />
      <span>{{ $t('noTransactions') }}</span>
    </div>
    <div class="transactions-loader" v-if="loading">
      <Spinner />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Spinner from '@/components/Spinner'
export default {
  name: 'PaymentsTransactions',
  data () {
    return {
      loading: false
    }
  },
  components: {
    Spinner
  },
  computed: {
    ...mapGetters({
      balance: 'wallet/balance',
      transactions: 'wallet/transactions',
      affiliatesCount: 'affiliate/count',
      walletInfo: 'wallet/walletInfo',
      user: 'auth/user',
      usersList: 'entities/users/list'
    })
  },
  async created () {
    try {
      this.loading = true
      await this.fetchTransactions()
      this.getUserAvatars()
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e)
    } finally {
      this.loading = false
    }
  },
  methods: {
    ...mapActions({
      fetchTransactions: 'wallet/fetchTransactions',
      getUserProfiles: 'entities/users/getProfiles'
    }),
    getUserAvatars () {
      const idArray = []
      if (this.transactions && this.transactions.length) {
        this.transactions.forEach(item => {
          if (item.initHolaId && item.initHolaId !== this.user.id) {
            idArray.push(item.initHolaId)
          }
        })
      }
      this.getUserProfiles(idArray)
    },
    isPending (transaction) {
      return transaction.status === 'PENDING'
    },
    isWithdraw (transaction) {
      return ['Package purchase', 'Withdraw to Xpay'].includes(transaction.typeName)
    },
    showDetailTransaction (item) {
      this.$modal.show('transaction-detail', { item: item })
    },
    getUserAvatar (id) {
      const user = this.usersList.find(e => e.id === id)
      return user?.avatarLink || ''
    }
  }
}
</script>

<style lang="scss" module>
.history {
  max-height: 575px;
  overflow-y: scroll;
}
.historyItem {
  display: flex;
  align-items: center;
  margin-top: 12px;
  background-color: $main-bg-light;
  padding: 8px 20px;

  .status {
    border-radius: 50%;
    background-color: $text-success;
    width: 50px;
    height: 50px;
    display: flex;
    flex-shrink: 0;
    justify-content: center;
    align-items: center;
    margin-right: 12px;

    &.pending {
      background-color: #fafd00;
    }

    &.withdraw {
      background-color: $text-error;
    }

    &Icon {
      font-size: 18px;
      color: $text-lightest;
    }
  }

  .transactionAmount {
    font-size: 16px;
  }

  .transactionDesc {
    color: $text-mid-dark;
  }
}
</style>
<style lang="scss" scoped>
.transactions {
  position: relative;
  &-loader {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    background-color: #f2f2f2;
    justify-content: center;
    align-items: center;
    min-height: 500px;
    z-index: 2;
  }
  &-title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
  }
  &-list {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    padding-right: 5px;
    max-height: 550px;
    overflow-y: scroll;
    border-top: 0.5px solid #e8e8e8;
    border-bottom: 0.5px solid #e8e8e8;

    &::-webkit-scrollbar {
      width: 8px;
      position: absolute;
      background: rgba(17, 17, 17, 0.1);
    }
    &::-webkit-scrollbar-track {
      background: transparent;
      position: absolute;
      z-index: -2;
    }
    &::-webkit-scrollbar-thumb {
      background: #00b764;
      border-radius: 5px;
    }
  }
  &-item {
    width: 100%;
    padding: 20px 30px;
    border-top: 0.5px solid #e8e8e8;
    border-bottom: 0.5px solid #e8e8e8;
    user-select: none;
    cursor: pointer;
    transition: background $trans;
    &:hover {
      background: #cecece;
    }
    &__left {
      margin-right: 15px;
    }
    &__avatar {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      overflow: hidden;
      position: relative;
      &:after {
        content: '';
        display: block;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.15);
      }
      &:before {
        content: '';
        display: block;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 25px;
        height: 25px;
        background: url('../../assets/icons/custom/dolar-white.svg') center center no-repeat;
        background-size: contain;
        z-index: 2;
      }
      &.green {
        background: #00b763;
      }
      &.yellow {
        background: #fafd00;
      }
      &.red {
        background: #d90d0d;
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    &__info {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      &-amount {
        font-size: 14px;
        line-height: 1.1;
        font-weight: 700;
      }
      &-desc {
        font-size: 14px;
        line-height: 1.2;
        color: #9c9c9c;
      }
      &-level {
        font-size: 14px;
        line-height: 1.1;
        color: #9c9c9c;
      }
    }
  }
  &-empty {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img {
      width: 100px;
      margin: 50px auto 20px;
    }
    span {
      font-size: 14px;
      line-height: 1.2;
      font-weight: 500;
    }
  }
}
</style>
